import { getParentQuestionThreads } from './getParentQuestionThreads';

export const hydrateQuestionThreads = ({ questionsById, getParentObject }) => {
  return Object.keys(questionsById).forEach((questionId) => {
    // generate the parent threads for this question
    const startingItem = questionsById[questionId];
    const parentThreads = getParentQuestionThreads({ startingItem, questionsById, getParentObject });

    // hydrate the required question threads for every required question item in a thread

    // loop through generated parent threads...
    parentThreads.forEach((thread) => {
      // loop through each item in the thread...
      thread.forEach((parent) => {
        const allParentRequiredThreads = [];
        const requiredQuestions = parent.requiredQuestions || [];

        // for each required question, get its own parent threads and add them to the allParentRequiredThreads array
        requiredQuestions.forEach((reqQuestionObject) => {
          const startingItem = questionsById[reqQuestionObject.parentId];
          const requiredThreads = getParentQuestionThreads({
            startingItem,
            questionsById,
            getParentObject,
            reqQuestionObject,
          });

          allParentRequiredThreads.push(...requiredThreads);
        });

        parent.requiredQuestionThreads = allParentRequiredThreads;
      });
    });

    questionsById[questionId].parentThreads = parentThreads;
  });
};
